import { ReactNode } from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'

import AuthProvider from './auth-provider'
import MuiThemeProvider from './mui-theme-provider'
import SnackbarNotificationProvider from './snackbar-provider'

const AllProviders = ({ children }: { children: ReactNode[] | ReactNode }) => {
  return (
    <SnackbarNotificationProvider>
      <AuthProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <MuiThemeProvider>{children}</MuiThemeProvider>
        </LocalizationProvider>
      </AuthProvider>
    </SnackbarNotificationProvider>
  )
}

export default AllProviders
